// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.doc_req_pop[data-v-10973808] {width:910px; height: 600px; overflow-y: scroll;}\n.doc_req_pop > .layer_close[data-v-10973808] {z-index: 10;}\n.div_cntr_area + .div_cntr_area[data-v-10973808] {margin-top: 5px;}\n.text_link[data-v-10973808] {color: #000; padding-left: 2px;}\n.text_link[data-v-10973808]:hover {text-decoration: underline !important;}\n.attdel[data-v-10973808] {cursor: pointer;}\n", ""]);
// Exports
module.exports = exports;
